import { useState } from "react"

import {
  getAgentCoreSettingsRequest,
  isAgentCoreSettingsValid
} from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"

import type {
  AgentCorePreInstall,
  AgentCoreSettings
} from "@/api/useDeployments.types"

// The template of the settings it was rendered for, loaded on download; a
// settings change resets it, for the next download to render the new one
export const useAgentCoreTemplate = (
  preInstall: (
    settings: AgentCoreSettings
  ) => Promise<AgentCorePreInstall | undefined>
) => {
  const [rendered, setRendered] = useState<AgentCorePreInstall>()

  const getTemplate = async (settings: AgentCoreSettings) => {
    // A template for invalid settings (control without a tag) could never be connected
    if (!isAgentCoreSettingsValid(settings)) return undefined

    const result =
      rendered ?? (await preInstall(getAgentCoreSettingsRequest(settings)))

    setRendered(result)

    return result?.cloudformationTemplate
  }

  return {
    getTemplate,
    reset: () => setRendered(undefined)
  }
}
